import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// Optional web-vitals reporting can be configured here.
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
